import { render, staticRenderFns } from "./PublicationsPage.vue?vue&type=template&id=706c49af&scoped=true"
import script from "./PublicationsPage.vue?vue&type=script&lang=js"
export * from "./PublicationsPage.vue?vue&type=script&lang=js"
import style0 from "./PublicationsPage.vue?vue&type=style&index=0&id=706c49af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706c49af",
  null
  
)

export default component.exports